'use strict';

export default class MiniSearch {
  constructor(options) {
    console.log('MiniSearch module');

    const defaults = {
      acInputs: '#location',
      submitButton: '.miniSearch__button',
      selects: {
        searchType: '.miniSearch select[name="type"]',
        searchService: '.miniSearch select[name="service"]',
        searchLogement: '.miniSearch select[name="type_de_logement"]',
        searchRecherchez: '.miniSearch select[name="vous_recherchez"]'
      }
    };

    this.options = Object.assign({}, defaults, options);
    this.ac = [];
    this.searchValue = null; //autocomplete value
    this.searchType = null; //House type or aide a domicile
    this.searchService = null; //aide a domicile services
    this.searchLogement = null; //RS types
    this.searchRecherchez = null;//MR types
    this.urlToFollow = window.location.href;

    //auto init
    this._applyAutoComplete();
    this._listemForm();
  }

  _listemForm() {

    $.each(this.options.selects, function(i, obj) {

      $(obj).on('change', function(evt) {
        evt.preventDefault();
        this._changeUrl();
      }.bind(this)).trigger('change', true);

    }.bind(this));

    $(this.options.acInputs).on('keyup change', function(evt) {
      this._changeUrl();
    }.bind(this));

    $(this.options.submitButton).on('click touchend', function(evt) {
        evt.preventDefault();
        if(this.searchValue !== '') {
          window.location.href = this.urlToFollow;
        } else {
          $(this.options.acInputs).focus();
        }
    }.bind(this));

  }

  _pacSelectFirst(input) {
      // store the original event binding function
      var _addEventListener = (input.addEventListener) ? input.addEventListener : input.attachEvent;

      function addEventListenerWrapper(type, listener) {
          // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
          // and then trigger the original listener.
          if (type == "keydown") {
              var orig_listener = listener;
              listener = function(event) {
                  var suggestion_selected = $(".pac-item-selected").length > 0;
                  if (event.which == 13 && !suggestion_selected) {
                      var simulated_downarrow = $.Event("keydown", {
                          keyCode: 40,
                          which: 40
                      });
                      orig_listener.apply(input, [simulated_downarrow]);
                  }

                  orig_listener.apply(input, [event]);
              };
          }

          _addEventListener.apply(input, [type, listener]);
      }

      input.addEventListener = addEventListenerWrapper;
      input.attachEvent = addEventListenerWrapper;
  }

  _applyAutoComplete() {
    let acOptions = {
        componentRestrictions: {country: "fr"}
    };

    $.each($(this.options.acInputs), function(i, elem) {

      this._pacSelectFirst(elem);

      this.ac = {};

      elem.addEventListener('input', function(event) {
        if ((Object.entries(this.ac).length === 0 && this.ac.constructor === Object) && (event.target.value.length >= 3)) {
          this.ac.autocomplete = new google.maps.places.Autocomplete(document.getElementById(event.target.id), this.acOptions);
          this.ac.inputId = elem.id;

          this.ac.autocompleteLsr = google.maps.event.addListener(this.ac.autocomplete, 'place_changed', function () {
            this._changeUrl();
          }.bind(this));

          setTimeout(function(){
            google.maps.event.trigger(document.getElementById(event.target.id), 'keydown', { keyCode: 39 });
          }.bind(this), 200);
        }
        else if ((Object.entries(this.ac).length !== 0 && this.ac.constructor === Object) && (event.target.value.length <= 2)) {
          google.maps.event.removeListener(this.ac.autocompleteLsr);
          google.maps.event.clearInstanceListeners(document.getElementById(event.target.id));
          $(".pac-container").remove();
          this.ac = {};
        }
      }.bind(this));

    }.bind(this));
  }

  _changeUrl() {

    this.searchValue = $(this.options.acInputs).val(); //autocomplete value
    this.searchType = $(this.options.selects.searchType).val(); //House type or aide a domicile
    this.searchService = $(this.options.selects.searchService).val(); //aide a domicile services
    this.searchLogement = $(this.options.selects.searchLogement).val(); //RS types
    this.searchRecherchez = $(this.options.selects.searchRecherchez).val();//MR types

    this.urlToFollow = window.location.origin + '/' +
                         this._getHouseTypeUrl() +
                         this.searchValue;

    switch(this.searchType){

      case 'mr_search_string':
      this.urlToFollow += "/recherchez/" + this.searchRecherchez;
      break;

      case 'rs_search_string':
      this.urlToFollow += "/logement/" + this.searchLogement;
      break;

      case 'ad_search_string':
      this.urlToFollow += "/service/" + this.searchService;
      break;

      default:
      break;
    }

  }

  _getHouseTypeUrl() {

    $(this.options.selects.searchService).parent().hide();
    $(this.options.selects.searchLogement).parent().hide();
    $(this.options.selects.searchRecherchez).parent().hide();

    switch(this.searchType){
      case 'tous_search_string':
      return 'recherche/tous/';
      break;

      case 'mr_search_string':
      $(this.options.selects.searchRecherchez).parent().show();
      return 'recherche/maisons-de-retraite/';
      break;

      case 'rs_search_string':
      $(this.options.selects.searchLogement).parent().show();
      return 'recherche/residence-seniors/';
      break;

      case 'ad_search_string':
      $(this.options.selects.searchService).parent().show();
      return 'recherche/aide-a-domicile/';
      break;

      default:
      return 'recherche/tous/';
      break;
    }

  }
}
